import axios from "axios";
import qs from "qs";
import { addSignature } from "@/utils/signature";
import sma from "@/utils/sma";
import store from "@/store";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // 添加域名
  addSignature: false,
  // 添加token
  addToken: false,
  withCredentials: false,
  timeout: 10000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  // 在向服务器发送前，转换请求数据
  transformRequest: [
    function (data, headers) {
      if (
        data &&
        headers["Content-Type"] === "application/x-www-form-urlencoded"
      ) {
        for (const [key, value] of Object.entries(data)) {
          if (Object.prototype.toString.call(value) === "[object Object]") {
            data[key] = JSON.stringify(value);
          }
        }
        data = qs.stringify(data);
      }
      return data;
    },
  ],
});

instance.interceptors.request.use(
  (config) => {
    if (config.addToken) {
      // 为API增加token
      config.params = {
        ...config.params,
        token: store.state.token,
      };
    }
    if (config.addSignature) {
      // 为API增加签名
      config = addSignature(config);
    }
    return config;
  },
  (error) => {
    return Promise.request(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    console.log("ajax响应结果", response);
    const res = response.data;
    if (
      res.code === 0 ||
      (response.config.baseURL === process.env.VUE_APP_BASE_API &&
        res.statusCode === 200)
    ) {
      return Promise.resolve(res);
    } else {
      if (res.code === 100000099) {
        sma.login();
      }
      if (res.code == 100000011 || res.code == 100010007) {
        window.location.href = location.origin + process.env.BASE_URL + "api";
        return false;
      }
      if (res.code === 100000004) {
        res.errorMsg =
          Array.isArray(res.error) && res.error.length > 0
            ? res.error[0].value
            : res.msg;
      } else {
        res.errorMsg = res.msg;
      }
      return Promise.reject(res);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
